// Shared room cost/needs helpers used by the room reports.
// Mirrors the item-cost logic in GenerateRoomStatusReport so figures match.

export const DOWN_STATUSES = ["Down", "Facilities"];

export const isDownRoom = (room) => DOWN_STATUSES.includes(room?.status);

/**
 * Items needed for a single room, derived from its itemCount* fields.
 * @returns Array<{ itemID, itemName, vendorName, unitCost, qty, lineTotal }>
 */
export const itemsNeededForRoom = (room, items) => {
  const out = [];
  Object.keys(room || {}).forEach((key) => {
    if (!key.startsWith("itemCount")) return;
    const qty = Number(room[key]) || 0;
    if (qty <= 0) return;
    const matched = (items || []).find((it) => it.itemID === key);
    if (!matched) return;
    const unitCost = Number.parseFloat(matched.itemCost) || 0;
    out.push({
      itemID: key,
      itemName: matched.itemName || key.replace("itemCount", ""),
      vendorName:
        (matched.vendor || "").toString().trim() || "Unassigned Vendor",
      unitCost,
      qty,
      lineTotal: unitCost * qty,
    });
  });
  return out;
};

/** Total item cost to bring a single room up. */
export const roomCost = (room, items) =>
  itemsNeededForRoom(room, items).reduce((s, r) => s + r.lineTotal, 0);
